import * as types from '../mutation-types'

// initial state
const state = {
  list: null,
  data: null,
  slideCategories: null,
  coachCategories: null
}

// mutations
const mutations = {
  [types.COACH_LIST] (state, action) {
    state.list = action
  },

  [types.GET_COACH_DATA] (state, action) {
    state.data = action
  },

  [types.MENU_LIST] (state, action) {
    state.slideCategories = action.data.slideCategories
    state.coachCategories = action.data.coachCategories
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/coach.js